module.exports = __webpack_public_path__ + "img/Fr-studio.dc066007.gif";